const trapFocusHandlers = {};
/**
 * Returns the focusable descendants of `container` for the global
 * focus-trap implementation.
 * @param {ParentNode} container
 * @returns {HTMLElement[]}
 */ function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}
/**
 * Traps keyboard focus inside `container` while it is active, wrapping Tab
 * between the first and last focusable descendants and reverting stray
 * `focusin` events back to the first focusable element.
 * @param {HTMLElement} container
 * @returns {void}
 */ export function trapFocus(container) {
  removeTrapFocus();
  const focusable = getFocusableElements(container);
  if (!focusable.length) {
    console.warn(
      '[BritaHub] trapFocus called on container with no focusable elements.',
    );
    return;
  }
  const first = focusable[0];
  const last = focusable[focusable.length - 1];
  trapFocusHandlers.keydown = (event) => {
    if (event.key !== 'Tab') return;
    const activeEl = document.activeElement;
    if (!event.shiftKey && activeEl === last) {
      event.preventDefault();
      first?.focus();
    } else if (
      event.shiftKey &&
      (activeEl === first || activeEl === container)
    ) {
      event.preventDefault();
      last?.focus();
    }
  };
  trapFocusHandlers.focusin = (event) => {
    if (event.target instanceof Node && !container.contains(event.target)) {
      event.stopPropagation();
      first?.focus();
    }
  };
  document.addEventListener('keydown', trapFocusHandlers.keydown, true);
  document.addEventListener('focusin', trapFocusHandlers.focusin, true);
  container.focus();
}
/**
 * Removes the document-level keydown and focusin listeners previously
 * installed by `trapFocus`. Safe to call when no trap is active.
 * @returns {void}
 */ export function removeTrapFocus() {
  trapFocusHandlers.keydown &&
    document.removeEventListener('keydown', trapFocusHandlers.keydown, true);
  trapFocusHandlers.focusin &&
    document.removeEventListener('focusin', trapFocusHandlers.focusin, true);
}
